import { Card } from '@braze/web-sdk';
import { map, MonoTypeOperatorFunction, Observable } from 'rxjs';

/**
 * Filter RxJs operator function for Braze Content Cards.
 *
 * This function truncates the max number of returned cards in a stream to the
 * `max` cards in the array.
 *
 * @param max - Total number of cards allowed.
 * @returns The truncated listed of content cards.
 */
export const truncateContentCards =
  <T extends Card>(max: number): MonoTypeOperatorFunction<T[]> =>
  (source$: Observable<T[]>): Observable<T[]> =>
    source$.pipe(
      map((cards) => {
        if (cards.length > max) {
          return cards.slice(0, max);
        }
        return cards;
      }),
    );
